import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractDomain',
})
export class ExtractDomainPipe implements PipeTransform {
  transform(url: string): string {
    try {
      // Handle cases where the input might already be a domain
      if (!url.includes('://')) {
        url = 'https://' + url;
      }
      const domain = new URL(url).hostname;
      return domain.startsWith('www.') ? domain.slice(4) : domain;
    } catch {
      console.warn('Failed to extract domain from:', url);
      return url;
    }
  }
}
